module.exports = __webpack_public_path__ + "img/YEL.37039962.svg";